export const REDIRECT_FROM_TABS = 'redirectFromTabs';
export const TAB_NOTIFICATIONS_STATUS = 'tabNotificationsStatus';
export const SHOW_NOTIFICATION = 'showNotification';
export const TIME_FOR_HIDING_NOTIFICATION = 10000;

export enum CLIPPING_DIRECTION {
    right = 'right',
    left = 'left',
    unknown = 'unknown'
}

export const TOP_MENU_PORTAL = 'TOP_MENU_PORTAL';
